import { useEffect, useRef } from "react";
import { useRetreat } from "./useRetreat";
import { logEngineTransition } from "../debug/uiLog";

export function useEngineTransitionLog(): void {
  const snapshot = useRetreat();
  const prevStatusRef = useRef(snapshot.status);

  useEffect(() => {
    if (snapshot.status !== prevStatusRef.current) {
      logEngineTransition(prevStatusRef.current, snapshot.status);
      prevStatusRef.current = snapshot.status;
    }
  }, [snapshot.status]);
}
